<template>
  <div class="image-horizontal-scroll-container">
    <div>list：{{listData.length}}</div>
    <vue-seamless-scroll
      :data="listData"
      :class-option="classOption"
      class="warp"
      ref="seamlessScrollRef"
      @ScrollEnd="scrollEnd('listData', 'seamlessScrollRef')"
    >
      <div class="img-block">
        <img
          v-for="(item, index) in listData"
          :key="index"
          :src="item"
          alt=""
          class="img-item"
        >
      </div>
    </vue-seamless-scroll>
  </div>
</template>
<script>
const sourceList = [
  'https://portal.fuyunfeng.top/files/constellation/1.jpg',
  'https://portal.fuyunfeng.top/files/constellation/2.jpg',
  'https://portal.fuyunfeng.top/files/constellation/3.jpg',
  'https://portal.fuyunfeng.top/files/constellation/4.jpg',
  'https://portal.fuyunfeng.top/files/constellation/5.jpg',
  'https://portal.fuyunfeng.top/files/constellation/6.jpg',
  // 'https://portal.fuyunfeng.top/files/constellation/7.jpg',
  // 'https://portal.fuyunfeng.top/files/constellation/8.jpg',
  // 'https://portal.fuyunfeng.top/files/constellation/9.jpg',
  // 'https://portal.fuyunfeng.top/files/constellation/10.jpg',
  // 'https://portal.fuyunfeng.top/files/constellation/11.jpg',
  // 'https://portal.fuyunfeng.top/files/constellation/12.jpg',
]
const maxImages = 20;

export default {
  name: 'ImageHorizontalScroll',
  props: {
    customClassOption: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      listData: [],
      defaultClassOption: {
        direction: 2,
        step: 1.2
      },
    }
  },
  computed: {
    classOption() {
      return {
        ...this.defaultClassOption,
        ...this.customClassOption
      }
    }
  },
  mounted() {
    this.getBasicData()
  },
  methods: {
    sleepUtil(sleep = 500) {
      return new Promise(resolve => {
        setTimeout(() => {
          resolve()
        }, sleep)
      })
    },
    async getBasicData() {
      await this.sleepUtil(200)
      this.listData = [...sourceList]
      this.getPushData()
    },
    async getPushData() {
      setInterval(async () => {
        const newList = [
          'https://portal.fuyunfeng.top/files/Naruto/021447451148.jpg',
          'https://portal.fuyunfeng.top/files/Naruto/021447524230.jpg',
          'https://portal.fuyunfeng.top/files/Naruto/021447525124.jpg',
          'https://portal.fuyunfeng.top/files/Naruto/021447525139.jpg',
          'https://portal.fuyunfeng.top/files/Naruto/021447526633.jpg',
          'https://portal.fuyunfeng.top/files/Naruto/021447532253.jpg',
          // 'https://portal.fuyunfeng.top/files/Naruto/021447539842.jpg',
          // 'https://portal.fuyunfeng.top/files/Naruto/021447551121.jpg',
          // 'https://portal.fuyunfeng.top/files/Naruto/021447551573.jpg',
          // 'https://portal.fuyunfeng.top/files/Naruto/021447552447.jpg',
          // 'https://portal.fuyunfeng.top/files/Naruto/021447553023.jpg',
          // 'https://portal.fuyunfeng.top/files/Naruto/021447554014.jpg',
          // 'https://portal.fuyunfeng.top/files/Naruto/021447555034.jpg',
          // 'https://portal.fuyunfeng.top/files/Naruto/021447556043.jpg',
          // 'https://portal.fuyunfeng.top/files/Naruto/021447559332.jpg',
          // 'https://portal.fuyunfeng.top/files/Naruto/021447559537.jpg',
          // 'https://portal.fuyunfeng.top/files/Naruto/021447559766.jpg',
          // 'https://portal.fuyunfeng.top/files/Naruto/021447559933.jpg',
        ];

        if (this.listData.length > maxImages) return this.replaceImagesInBatches(newList, 'listData', 'seamlessScrollRef')

        this.addImagesInBatches(newList, 'listData', 'seamlessScrollRef')
      }, 3000);
    },
    addImagesInBatches(newImages, dataList, refName) {
      const batchSize = 3;
      const imagesCopy = [...newImages];

      const addImagesInBatches = (deadline) => {
        if (deadline.timeRemaining() > 0 && imagesCopy.length > 0) {
          const imagesToAdd = imagesCopy.splice(0, batchSize);
          this[dataList].push(...imagesToAdd)
          this.$refs[refName].reset();
        }

        if (imagesCopy.length) requestIdleCallback(addImagesInBatches);
      };

      requestIdleCallback(addImagesInBatches);
    },
    replaceImagesInBatches(newImages, dataList, refName) {
      this[dataList].splice(0, 6, ...newImages);
      this.$refs[refName].reset();
    },
    scrollEnd(dataList, refName) {
      this[dataList].splice(0, this[dataList].length - 6)
      this.$refs[refName].reset();
    }
  }
}
</script>
<style lang="stylus" scoped>
.warp {
  width: 130px * 4;
  height: 120px;
  margin: 50px auto;
  overflow: hidden;

  .img-block {
    margin: 0 auto;
    display: flex;

    .img-item {
      width: 120px;
      height: 120px;
      margin-right: 10px;
    }
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0 auto;

    &.ul-item {
      display: flex;

      .li-item {
        width: 120px;
        height: 120px;
        margin-right: 10px;
        line-height: 120px;
        background-color: #999;
        color: #fff;
        text-align: center;
        font-size: 30px;
      }
    }
  }
}
</style>
